<script lang="ts">
    import cn from 'classnames';

    import { Button } from '@uikit/button';
    import { IconName, SvgIcon } from '@uikit/svg-icon';

    import type { AccordionItem } from './types';

    import s from './accordion.module.css';

    export let items: AccordionItem[] = [];
    export let rootClasses = '';
    export let titleClasses = '';
    export let textClasses = '';
    export let closeButtonClasses = '';
</script>

<dl class={cn(s.root, rootClasses)}>
    {#each items as item}
        <dt class={cn(s.title, titleClasses)} on:click={() => item.isActive = !item.isActive}>
            {item.title}
            <Button classes={cn(s.closeButton, closeButtonClasses, { [s.active]: item.isActive })}>
                <SvgIcon icon={IconName.Close} />
            </Button>
        </dt>
        <dd class={cn(s.text, textClasses, { [s.active]: item.isActive })}>
            <slot {item}></slot>
        </dd>
    {/each}
</dl>
